/**
 * Filter popups: only one open at a time, Escape closes, focus returns to the summary.
 * Click-outside is handled in CSS (invisible layer under the open panel).
 */
(() => {
  const SELECTOR = 'details.facets__disclosure';
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.matches(SELECTOR) || !details.open) return;
      document.querySelectorAll(`${SELECTOR}[open]`).forEach((other) => {
        if (other !== details) other.removeAttribute('open');
      });
    },
    true
  );
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector(`${SELECTOR}[open]`);
    if (!open) return;
    open.removeAttribute('open');
    open.querySelector('summary')?.focus();
  });
})();
